import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, KeyRound } from "lucide-react";

const Row = ({ label, value, copy, testid }) => (
  <div>
    <div className="text-xs font-semibold text-slate-600 mb-1">{label}</div>
    <div className="flex gap-2">
      <Input readOnly value={value || ""} className="font-mono text-xs" data-testid={testid}/>
      <Button size="icon" variant="outline" onClick={() => copy(value)} data-testid={`${testid}-copy`}><Copy className="w-4 h-4"/></Button>
    </div>
  </div>
);

export const AgentCredentialDialog = ({ data, onClose, copy }) => (
  <Dialog open={!!data} onOpenChange={(v) => { if (!v) onClose(); }}>
    <DialogContent className="max-w-lg" data-testid="agent-credential-dialog">
      <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5"/>Credencial do Agente Local</DialogTitle></DialogHeader>
      {data && (
        <div className="space-y-3 text-sm">
          <div className="p-3 rounded-lg bg-amber-50 border border-amber-200 text-amber-900 text-xs" data-testid="agent-credential-warning">
            Copie agora: o token aparece <strong>uma única vez</strong> e fica guardado no sistema só cifrado. Se perder, gere outro (o anterior deixa de funcionar).
          </div>
          <div className="text-xs text-slate-600">Dispositivo: <strong>{data.device}</strong> · Unidade: <strong>{data.unit_name || "—"}</strong></div>
          <Row label="ID da unidade (campo unit_id)" value={data.unit_id} copy={copy} testid="agent-credential-unit"/>
          <Row label="Token do dispositivo (campo token)" value={data.token} copy={copy} testid="agent-credential-token"/>
          <p className="text-[11px] text-slate-500">Cole os dois na tela de configuração do agente (American Fit Agente) e clique em Salvar e depois Testar servidor.</p>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
